import App from './app';
export { default as App } from './app';
import { UserID, UserAnonymousID, Metadata, RawCustomEvent } from './messages';
import * as _Messages from './messages';
export const Messages = _Messages;
import Connection from './modules/connection';
import Console from './modules/console';
import Exception from './modules/exception';
import Img from './modules/img';
import Input from './modules/input';
import Mouse from './modules/mouse';
import Timing from './modules/timing';
import Performance from './modules/performance';
import Scroll from './modules/scroll';
import Viewport from './modules/viewport';
import Longtask from './modules/longtask';
function isOptions(obj) {
    if (obj == null) {
        return false;
    }
    if (typeof obj.projectID !== 'number') {
        return false;
    }
    if (typeof obj.sessionID !== 'string' && obj.sessionID != null) {
        return false;
    }
    return true;
}
export default class API {
    constructor(options) {
        if (!isOptions(options)) {
            if (process.env.NODE_ENV !== 'production') {
                console.error("Asayer: invalid options argument type. Please, check documentation on https://docs.asayer.io");
            }
            this.app = null;
            return;
        }
        this.app =
            location.protocol !== 'https:' ||
                navigator.doNotTrack == '1' ||
                window.doNotTrack ||
                !('Map' in window) ||
                !('Set' in window) ||
                !('MutationObserver' in window) ||
                !('performance' in window) ||
                !('timing' in performance) ||
                !('startsWith' in String.prototype)
                ? null
                : new App(options.projectID, options.sessionID, options);
        if (this.app !== null) {
            Connection(this.app);
            Console(this.app, options);
            Exception(this.app, options);
            Img(this.app);
            Input(this.app, options);
            Mouse(this.app);
            Timing(this.app, options);
            Performance(this.app);
            Scroll(this.app);
            Viewport(this.app);
            Longtask(this.app, options);
            if (typeof window.__ASAYER__ === 'undefined') {
                window.__ASAYER__ = this.app;
            }
        }
    }
    use(fn) {
        return fn(this.app);
    }
    active() {
        if (this.app === null) {
            return false;
        }
        return this.app.active();
    }
    start() {
        if (this.app === null) {
            return;
        }
        this.app.start();
    }
    stop() {
        if (this.app === null) {
            return;
        }
        this.app.stop();
    }
    sessionID() {
        if (this.app === null) {
            return null;
        }
        return this.app.sessionID();
    }
    userID(id) {
        if (typeof id === 'string' && this.app !== null) {
            this.app.send(UserID(id));
        }
    }
    userAnonymousID(id) {
        if (typeof id === 'string' && this.app !== null) {
            this.app.send(UserAnonymousID(id));
        }
    }
    metadata(key, value) {
        if (typeof key === 'string' &&
            typeof value === 'string' &&
            this.app !== null) {
            this.app.send(Metadata(key, value));
        }
    }
    event(key, payload) {
        if (typeof key === 'string' && this.app !== null) {
            this.app.safe(() => this.app.send(RawCustomEvent(key, JSON.stringify(payload))))();
        }
    }
}
